<h1 class="_home-page-content-tab-label">Order Now For Collection</h1>

<div class="takeaway-tab-content" style="align-items: center" *ngIf="showNoSitesError">
  <p class="_home-page-content-tab-error">There are no stores to show.</p>
</div>

<ng-container *ngIf="supportedSites.length > 0">
  <div class="takeaway-tab-shouldRedirect" *ngIf="noStoresFound">
    Sorry - we don't deliver to your postcode, please place a collection order instead
  </div>

  <app-home-page-store-dropdown [stores]="supportedSites" [occasion]="occasion" (onSelection)="onSelection.emit($event)"></app-home-page-store-dropdown>
</ng-container>


